import React from 'react';

/**
 * Skeleton placeholder for loading states.
 * Use className to set width/height; defaults to a subtle neutral block.
 */
const Skeleton = ({ className = '' }) => (
  <div className={`animate-pulse rounded-md bg-gray-200 dark:bg-navy-700/70 ${className}`} />
);

export default Skeleton;
